import App from './App';

const site = new App();
window.onload = () => {
  site.init();
};
